import { render, staticRenderFns } from "./WorkReport.vue?vue&type=template&id=4ef7917c&scoped=true"
import script from "./WorkReport.vue?vue&type=script&lang=js"
export * from "./WorkReport.vue?vue&type=script&lang=js"
import style0 from "./WorkReport.vue?vue&type=style&index=0&id=4ef7917c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef7917c",
  null
  
)

export default component.exports